import {
    CHATBOT_ERROR,
    CHATBOT_RESET,
    ASK_CHATBOT
} from '../actions/types';

const INITIAL_STATE = {
    chatbot: '',
    error: '',
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ASK_CHATBOT:
            return {
                ...state,
                chatbot: action.payload.data,
                error: ''
            };
        case CHATBOT_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case CHATBOT_RESET:
            return INITIAL_STATE;

        default:
            return {
                ...state
            }
    }

    //return state;
}
